module.exports = __webpack_public_path__ + "img/epayments.79ab20ef.png";